import React, { useState } from 'react';
import { submitFeedback } from "../services/feedbackService";
import '../styles/feedback.css';

const FeedbackPage = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        category: 'Feedback',
        subject: '',
        message: '',
        imageBase64: '',
    });

    const [submitted, setSubmitted] = useState(false);
    const [responseMsg, setResponseMsg] = useState('');
    const [errorMsg, setErrorMsg] = useState('');

    const handleChange = (e) => {
        const { name, value, files } = e.target;

        if (name === 'image') {
            const file = files[0];
            if (!file) return;

            const reader = new FileReader();
            reader.onloadend = () => {
                const base64 = reader.result.split(",")[1]; // remove data:image/... prefix
                setFormData((prevData) => ({
                    ...prevData,
                    imageBase64: base64,
                }));
            };
            reader.readAsDataURL(file);
        } else {
            setFormData((prevData) => ({
                ...prevData,
                [name]: value,
            }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setResponseMsg('');
        setErrorMsg('');
        setSubmitted(false);

        try {
            await submitFeedback(formData);
            setSubmitted(true);
            setResponseMsg("Thank you for your feedback!");
            setFormData({
                name: '',
                email: '',
                category: 'Feedback',
                subject: '',
                message: '',
                imageBase64: '',
            });
            window.scrollTo(0, 0); // Scroll to top to see success message
        } catch (error) {
            setErrorMsg(error.message);
        }
    };

    return (
        <div className="container py-5">
            {/* Header Section */}
            <div className="text-center mb-5 feedback-header">
                <h1 className="display-5">Feedback & Contributions</h1>
                <p className="lead">
                    Help us improve the Scientific Data Hub. Submit bug reports, feature requests, or general feedback below.
                </p>
            </div>

            {/* Form Section */}
            <div className="row justify-content-center">
                <div className="col-lg-8">
                    <div className="feedback-card">

                        {submitted ? (
                            <div className="feedback-alert feedback-alert-success">
                                <i className="bi bi-check-circle-fill"></i>
                                <div>
                                    <strong>Success:</strong> {responseMsg}
                                    <br />
                                    <span className="small">We appreciate your input and will review it shortly.</span>
                                </div>
                            </div>
                        ) : (
                            <form onSubmit={handleSubmit}>
                                {errorMsg && (
                                    <div className="feedback-alert feedback-alert-danger">
                                        <i className="bi bi-exclamation-triangle-fill"></i>
                                        {errorMsg}
                                    </div>
                                )}

                                <div className="row">
                                    <div className="col-md-6 scientific-form-group">
                                        <label className="scientific-label">Name (optional)</label>
                                        <input
                                            type="text"
                                            className="scientific-input"
                                            name="name"
                                            value={formData.name}
                                            onChange={handleChange}
                                            placeholder="Dr. Jane Doe"
                                        />
                                    </div>

                                    <div className="col-md-6 scientific-form-group">
                                        <label className="scientific-label">Email (optional)</label>
                                        <input
                                            type="email"
                                            className="scientific-input"
                                            name="email"
                                            value={formData.email}
                                            onChange={handleChange}
                                            placeholder="jane.doe@example.com"
                                        />
                                    </div>
                                </div>

                                <div className="scientific-form-group">
                                    <label className="scientific-label">Category</label>
                                    <select
                                        className="scientific-select"
                                        name="category"
                                        value={formData.category}
                                        onChange={handleChange}
                                    >
                                        <option value="Feedback">General Feedback</option>
                                        <option value="Feature Request">Feature Request</option>
                                        <option value="Bug Report">Bug Report</option>
                                        <option value="Data Correction">Data Correction / Flagging</option>
                                        <option value="Other">Other</option>
                                    </select>
                                </div>

                                <div className="scientific-form-group">
                                    <label className="scientific-label">Subject</label>
                                    <input
                                        type="text"
                                        className="scientific-input"
                                        name="subject"
                                        value={formData.subject}
                                        onChange={handleChange}
                                        required
                                        placeholder="Brief summary of your topic"
                                    />
                                </div>

                                <div className="scientific-form-group">
                                    <label className="scientific-label">Message</label>
                                    <textarea
                                        className="scientific-textarea"
                                        name="message"
                                        rows="6"
                                        value={formData.message}
                                        onChange={handleChange}
                                        required
                                        placeholder="Please provide detailed feedback..."
                                    />
                                </div>

                                <div className="scientific-form-group">
                                    <label className="scientific-label">Attach Image (optional)</label>
                                    <input
                                        type="file"
                                        name="image"
                                        accept="image/*"
                                        className="scientific-file-input"
                                        onChange={handleChange}
                                    />
                                    <small className="text-muted d-block mt-1">
                                        Useful for screenshots or data visualizations.
                                    </small>
                                </div>

                                <div className="text-center mt-4">
                                    <button type="submit" className="btn-scientific-submit">
                                        Submit Feedback
                                    </button>
                                </div>
                            </form>
                        )}
                    </div>

                    {/* Additional Context - Outside the card */}
                    {!submitted && (
                        <div className="text-center mt-4 text-muted small">
                            <p>
                                By submitting this form, you agree to our community guidelines.
                                <br />
                                For urgent matters, please contact us directly via the <a href="/contact">Contact Page</a>.
                            </p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default FeedbackPage;
